import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Building2, Briefcase, Users, Heart, CheckCircle } from 'lucide-react';

const LandingPage = () => {
  const services = [
    {
      icon: Building2,
      title: 'Business Insurance',
      description: 'Archon Insurance offers a full range of cost-effective commercial insurance and risk management solutions. From growing start-ups to long-standing companies, businesses rely on Archon Insurance for insurance options that help safeguard their success.',
    },
    {
      icon: Briefcase,
      title: 'Enterprise for Small Business',
      description: 'We provide a wide selection of business insurance solutions to help safeguard your company and support your long-term success.',
    },
    {
      icon: Users,
      title: 'Personal Insurance Private Client',
      description: 'Your personal insurance needs are unique. Our experienced team can help you explore coverage options designed to help protect you and your family from unexpected losses.',
    },
    {
      icon: Heart,
      title: 'Benefits Solutions',
      description: 'Our practical experience and industry knowledge help us understand the challenges employers face and assist them in exploring suitable coverage options.',
    }
  ];

  const missionPoints = [
    'Provide our clients thoughtful counsel and relentless advocacy.',
    'Provide products and services designed to meet client needs while maintaining a strong focus on trust and client relationships.',
    'Commitment to the free agency of our team to represent our clients best interests.',
    'Commitment to the community.',
  ];

  const testimonials = [
    {
      quote: "The biggest change I saw in comparing one agent to another is their accessibility and their ability to explain in terms that were understandable. Thanks for being there for me.",
      author: "Massachusetts Business Owner"
    },
    {
      quote: "Our company has worked with Archon Insurance for a number of years. Their sense of urgency and knowledge of the insurance industry are second to none.",
      author: "Manufacturing Company Executive"
    },
    {
      quote: "Working with Archon solved a big problem for me and my company. I needed a complete review and overhaul of all my business coverages and they succeeded.",
      author: "Distribution Company Owner"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section with Background */}
      <section 
        className="hero-section"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1920&q=80')`,
        }}
        data-testid="hero-section"
      >
        <div className="hero-content">
          <div className="container-wide">
            <h1 className="main-heading">Let Our Specialists Help Fortify Your Business</h1>
            <p className="sub-heading">Real Advocacy. Real Partnership. Real Experts.</p>
            
            {/* Service Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
              {services.map((service, index) => (
                <div key={index} className="service-card" data-testid={`service-card-${index}`}>
                  <service.icon className="service-card-icon" strokeWidth={1} />
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <Link to="/quote" className="service-card-btn">
                    Let Us Help
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section" data-testid="mission-section">
        <div className="container-wide">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="mission-dots">
                <span className="mission-dot"></span>
                <span className="mission-dot"></span>
                <span className="mission-dot"></span>
              </div>
              <h2 className="mission-title">Our Mission</h2>
              <p className="mission-subtitle">
                Archon Insurance is committed to our clients, colleagues and community:
              </p>
              <ul className="mission-list">
                {missionPoints.map((point, index) => (
                  <li key={index}>
                    <CheckCircle className="mission-check" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="hidden lg:block">
              <img 
                src="https://images.unsplash.com/photo-1553484771-371a605b060b?w=600&q=80" 
                alt="Community" 
                className="w-full rounded opacity-90"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonial-section" data-testid="testimonials-section">
        <div className="container-wide">
          <div className="mission-dots mb-4">
            <span className="mission-dot"></span>
            <span className="mission-dot"></span>
            <span className="mission-dot"></span>
          </div>
          <h2 className="mission-title mb-10">From Our Customers' Perspective</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <p>"{testimonial.quote}"</p>
                <cite>— {testimonial.author}</cite>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#1a365d] py-16" data-testid="cta-section">
        <div className="container-narrow text-center">
          <h2 className="text-3xl font-serif text-white mb-4">Archon Insurance Agency</h2>
          <p className="text-white/80 mb-8">
            Then, Now & Always — serving Massachusetts businesses and families with comprehensive insurance solutions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/quote" className="btn-navy bg-[var(--gold)] hover:bg-[var(--gold-dark)]">
              Get a Quote
            </Link>
            <Link to="/about" className="btn-outline-navy border-white text-white hover:bg-white hover:text-[#1a365d]">
              Learn More
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
